import axios from "axios";
import { config } from "../common/config";

export const axiosBaseApiClient = axios.create({
    baseURL: config.API_URL,
});
